import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import { Card, InteractiveList } from '@tiendanube/components';
import { AiGeneratedBox } from 'commons/components';
import { useAiField, useAiGeneratedValues } from 'commons/hooks';
import { AI_FIELDS } from 'commons/services/AgentChatService/AgentChatActionBusTypes';

interface ProductTypeProps {
  isDigital: boolean;
  onChange: (data: { name: string; value: boolean }) => void;
}

function ProductType({ isDigital, onChange }: ProductTypeProps): JSX.Element {
  const { t } = useTranslation(Domain.CATALOG);

  const productTypeField = useAiField<boolean>({
    componentId: AI_FIELDS.PRODUCT_IS_DIGITAL,
    getValue: () => isDigital,
    onReplace: (value) =>
      onChange({
        name: 'isDigital',
        value,
      }),
  });

  const productTypeFieldState = useAiGeneratedValues<boolean>(
    AI_FIELDS.PRODUCT_IS_DIGITAL,
  );

  const handleOnChange = () => {
    onChange({ name: 'isDigital', value: !isDigital });

    productTypeFieldState.resetAiGeneratedValues();
  };

  const options = [
    {
      title: t('products.detail.physical'),
      name: 'physical',
      active: !isDigital,
    },
    {
      title: t('products.detail.digital'),
      name: 'digital',
      active: isDigital,
    },
  ];

  return (
    <AiGeneratedBox
      aiGenerated={productTypeFieldState.isAiGenerated}
      {...productTypeField.navigationAttributes}
    >
      <Card title={t('products.detail.typeOfProduct')}>
        <InteractiveList
          onChange={handleOnChange}
          mode="single"
          options={options}
        />
      </Card>
    </AiGeneratedBox>
  );
}

export default ProductType;
